export default __webpack_public_path__ + "static/media/logo-b.6feb8959.png";